module.exports = __webpack_public_path__ + "img/confirmer.9879b26b.png";